@if (subscription$ | async; as subscription) {
    <div>
        <h1 mat-dialog-title>Add/Remove Storage</h1>
        <div mat-dialog-content>
            <div class="flex column align-space-between">
                <div class="flex">
                    <p>
                        Storage can be added or removed in increments of {{ unit }} GB and will
                        automatically be added to your subscription and billing.
                    </p>
                </div>
                <mat-form-field class="flex">
                    <mat-label>Storage in GB</mat-label>
                    <input
                        type="text"
                        matInput
                        [formControl]="storageControl"
                        [matAutocomplete]="auto"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option [value]="0"> 0 </mat-option>
                        @for (option of filteredOptions | async; track option) {
                            <mat-option [value]="option">
                                {{ option }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            @if (storagePrice$ | async; as storagePrice) {
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>Included with plan</td>
                                <td>50GB</td>
                                <td>$0.00 / {{ subscription.interval }}</td>
                            </tr>
                            <tr>
                                <td>+</td>
                                <td>{{ storageControl.value }}GB</td>
                                <td>
                                    ${{
                                        ((storageControl.value / this.unit) * storagePrice) / 100
                                    }}.00 /
                                    {{ subscription.interval }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td>{{ +storageControl.value + this.unit }}GB</td>
                                <td>
                                    ${{
                                        ((+storageControl.value / this.unit) * storagePrice) / 100
                                    }}.00 /
                                    {{ subscription.interval }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            }
        </div>
        <div mat-dialog-actions>
            <button mat-button matDialogClose cdkFocusInitial>Cancel</button>
            <button mat-flat-button color="primary" (click)="send()">Submit</button>
        </div>
    </div>
}
